const CONTRACT_LIST_CACHE_ID = 'ContractList';
const CONTRACT_LIST_EVENT = {
  REFRESH: 'ContractListRefresh',
};

export {CONTRACT_LIST_CACHE_ID, CONTRACT_LIST_EVENT};
